window.onload = function () {
  if(document.querySelector(".globo-formbuilder")) {
    document.querySelector(".globo-formbuilder").getElementsByClassName("wizard__footer")[0].insertAdjacentHTML("afterbegin", '<div style="font-size: 12px;margin-bottom: 30px;text-align: left;">※入力が完了した時点で、<a href="/pages/privacy-policy/" target="_blank">プライバシーポリシー</a>に同意したものとみなします。</div>');
    const e = document.querySelectorAll(".js-required-check"),
      t = document.querySelector(".action.submit.flat-button");
    Array.from(e, s => {
      s.addEventListener("change", function () {
        c() === e.length ? (t.disabled = !1, t.classList.remove("is-disable")) : (t.disabled = !0, t.classList.add("is-disable"))
      })
    });
    const c = () => document.querySelectorAll(".js-required-check:checked").length;
    document.querySelector('.checkbox-input').checked = true;
  }

  UniqueId();

  // BirthDay();
};

function BirthDay (){

  /* セレクとボックスの親要素  */
  const parentDiv =document.querySelector("#form-select-4 > .globo-form-input")

  /*  年 */
  const select_year = document.createElement("select")
  const year = document.createElement("span")
  const yearText = "年"

      /*  月 */
  const select_month = document.createElement("select")
  const month = document.createElement("span")
  const monthText = "月"


  /*  日 */
  const select_day = document.createElement("select")
  const day = document.createElement("span")
  const dayText = "日"

  /*  input  */
  const input = document.querySelector("#form-select-4 > .globo-form-input > .flat-input")

  /*  セレクト追加 */
  const select = document.querySelector("#form-select-4 > .globo-form-input")


  let i;

  let yearNum = 1930,
  monthNum = 1,
  dayNum = 1

  function append() {

    select.appendChild(select_year)
    select.appendChild(select_month)
    select.appendChild(select_day)

    parentDiv.insertBefore(year, select_year.nextSibling);
    parentDiv.insertBefore(month, select_month.nextSibling);
    parentDiv.insertBefore(day, select_day.nextSibling);


    select_year.setAttribute("id", "select_year")
    select_year.setAttribute("class", "select_form")

    year.setAttribute("class", "select-kind")
    year.innerHTML = yearText



    select_month.setAttribute("id", "select_month")
    select_month.setAttribute("class", "select_form")


    month.setAttribute("class", "select-kind")
    month.innerHTML = monthText



    select_day.setAttribute("id", "select_day")
    select_day.setAttribute("class", "select_form")

    day.setAttribute("class", "select-kind")
    day.innerHTML = dayText
  }
  function $set_year(){
    // 年を生成
    for(i = yearNum; i < 2023; i++){
      let op = document.createElement('option');
      if(i == yearNum + parseInt((2023 - yearNum) / 2)) {
        op.setAttribute("selected", "")
      }
      // console.log(yearNum + parseInt((2023 - yearNum) / 2));
      op.value = i;
      op.text = i;
      select_year.appendChild(op);
    }
  }
  function $set_month(){
    // 月を生成(12)
    for(i = 1; i <= 12; i++){
      let op = document.createElement('option');
      op.value = i;
      op.text = i;
      select_month.appendChild(op);
    }
  }
  function $set_day(){
    //日の選択肢を空にする
    let children = select_day.children
    while(children.length){
      children[0].remove()
    }
    // 日を生成(動的に変える)
    if(select_year.value !== '' &&  select_month.value !== ''){
      const last_day = new Date(select_year.value,select_month.value,0).getDate()

      for (i = 1; i <= last_day; i++) {
        let op = document.createElement('option');
        op.value = i;
        op.text = i;
        select_day.appendChild(op);
      }
    }
  }
  function changeSelect(){
    select_year.addEventListener('change',() => {
      yearNum = select_year.value
      insertVal();
      // console.log( `${yearNum}年${monthNum}月${dayNum}日`);
    })
    select_month.addEventListener('change',() => {
      monthNum = select_month.value
      insertVal();
      // console.log( `${yearNum}年${monthNum}月${dayNum}日`);
    })

    select_day.addEventListener('change',() => {
      dayNum = select_day.value
      insertVal();
      // console.log( `${yearNum}年${monthNum}月${dayNum}日`);
    })



    function insertVal() {
      input.setAttribute("value", `${yearNum}年${monthNum}月${dayNum}日`)
      // console.log( `${yearNum}年${monthNum}月${dayNum}日`);
    }
  }

  const creatEle = new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 10);
  }).then(() => {

    append();
    $set_year();
    $set_month();
    $set_day();
  });

  const changeSelectEvent = new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 500);
  }).then(() => {
    changeSelect();

  });

  Promise.all([creatEle, changeSelectEvent]).then(() => {
    console.log("完了");
  });

}


function UniqueId(){
  const uniqueId = document.querySelectorAll(".layout-2-column");
  uniqueId.forEach((id ,i) => {
    id.setAttribute("id", `form-select-${i + 1}`)
  })
}